// extracted by mini-css-extract-plugin
export var deleteModal = "_hl-0";